<template>
  This content was generated with the assistance of AI, through workflows
  created by our team and audited regularly for quality. Please
  <a class="info-icon__link" href="/app/help"> report any issues</a>
  to help us get better.
</template>
